import React from 'react';
import '../css/HomePage.css';
import '../css/AboutUs.css';
import '../css/Services.css';
import Navigationbar from './NavigationBar';
import Footer from './Footer';
import { FaLinkedin, FaEnvelope } from 'react-icons/fa'; // Icons for LinkedIn and email
import { Link } from 'react-router-dom';
const Services = () => {
    // Example team members data
    const teamMembers = [
        { name: 'Member 1', email: 'member1@example.com', linkedin: 'https://linkedin.com/in/member1' },
        { name: 'Member 2', email: 'member2@example.com', linkedin: 'https://linkedin.com/in/member2' },
        { name: 'Member 3', email: 'member3@example.com', linkedin: 'https://linkedin.com/in/member3' },
        { name: 'Member 4', email: 'member4@example.com', linkedin: 'https://linkedin.com/in/member4' },
        { name: 'Member 5', email: 'member5@example.com', linkedin: 'https://linkedin.com/in/member5' }
    ];

    return (
        <div>
            <Navigationbar />
            <div className='HomePageContent'>
                <h1 className='HomePageHeaders'>Services</h1>
                <p>
                    Jumpstart your fitness journey with Fitness Tracker, the all-in-one platform designed to empower you to reach your health and wellness goals. Whether you're looking to track your daily activities, monitor your nutritional intake, or set and achieve specific fitness milestones, Fitness Tracker provides the tools you need for success.
                </p>
                <div className='HomePageAd'>
                    <video controls autoPlay loop muted>
                        <source src="/images/HomePageAd.mp4" type="video/mp4" />
                    </video>
                </div>
                <br></br>
                <br></br>
                <div className='HomePageFeatures'>
                    <div className='services-content'>
                <h1 className='services-header'>Our Services</h1>
                
                <div className='service'>
                    <h2>AI Assistant</h2>
                    <p>
                        Leverage our state-of-the-art AI Assistant to track your daily activities and get real-time suggestions tailored to your personal fitness goals. Our AI technology helps you optimize your routines and keeps you motivated every step of the way.
                    </p>
                </div>

                <div className='service'>
                    <h2>Personalized Nutritionist (Paid)</h2>
                    <p>
                        Subscribe to our premium service and gain access to a Personalized Nutritionist who will craft custom meal plans based on your dietary needs and fitness objectives. Enjoy bespoke nutritional guidance designed to fuel your body perfectly.
                    </p>
                </div>

                <div className='service'>
                    <h2>Personalized Trainer (Paid)</h2>
                    <p>
                        With our Personalized Trainer service, get tailor-made workout plans from certified fitness experts. Your personal trainer will work with you to create effective, enjoyable workout routines that fit your specific requirements and progress.
                    </p>
                </div>

                <div className='service'>
                    <h2>AI Curated Plans</h2>
                    <p>
                        Our sophisticated algorithms analyze your performance and preferences to dynamically adjust and suggest workout and nutrition plans. These AI-curated plans ensure you are always on the most efficient path to achieving your health goals.
                    </p>
                </div>

                <div className='service'>
                    <h2>Dashboards</h2>
                    <p>
                        Monitor your progress with our comprehensive dashboards that provide insights into your workouts, caloric intake, sleep patterns, and more. Our dashboards are designed to give you a clear overview of your health metrics at a glance.
                    </p>
                </div>
            </div>
                </div>
<br></br>
                <div className='FlashCards'>
                <h1 className='services-header'>Subscription Plans</h1>
                    <div className='services-price rowtype'>
                       

                        <div className='service columntype'>
                            <h2 style={{textAlign:'center'}}>Beginner Plan</h2>
                            <ul>
                                <li>Access to AI Assistant</li>
                                <li>Access to AI Curated Plans</li>
                                <li>Access to Dashboards</li>
                                </ul>
                                <br></br>
                                <div className='signup'>
                                            <Link className='signupbutton' to= "/" style={{textAlign:'center'}}>Free</Link>
                                            </div>
                        </div>

                        <div className='service columntype'>
                            <h2 style={{textAlign:'center'}}>Advanced Plan</h2>
                           <ul>
                           <li>Access to AI Assistant</li>
                                <li>Access to AI Curated Plans</li>
                                <li>Access to Dashboards</li>
                               <li>Access to Personalized Nutritionist</li>
                                <li>Access to Personalized Trainer</li>
                                <br></br>
                                <div className='signup'>
                                            <Link className='signupbutton' to= "/" style={{textAlign:'center'}}>$59.99 Monthly</Link>
                                            </div>
                           </ul>
                        </div>

                        <div className='service columntype'>
                            <h2 style={{textAlign:'center'}}>Premium Plan</h2>
                            <ul>
                                <li>Access to AI Assistant</li>
                                <li>Access to AI Curated Plans</li>
                                <li>Access to Dashboards</li>
                                <li>Access to Personalized Nutritionist</li>
                                <li>Access to Personalized Trainer</li>
                                <li>Access to Specialized AI model</li>
                                <br></br>
<div className='signup'>
            <Link className='signupbutton' to= "/" style={{textAlign:'center'}}>$99.99 Monthly</Link>
            </div>
                            </ul>
                        </div>

                        
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default Services;
